module.exports = ".glyphicon {\n  font-family: inherit; }\n\n.glyphicon:before {\n  font-family: 'Glyphicons Halflings'; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/export/others/export-others.component.scss
// module id = ./src/app/admin/export/others/export-others.component.scss
// module chunks = main